import { render, staticRenderFns } from "./Formater.vue?vue&type=template&id=41cc80fe&scoped=true&"
import script from "./Formater.vue?vue&type=script&lang=js&"
export * from "./Formater.vue?vue&type=script&lang=js&"
import style0 from "./Formater.vue?vue&type=style&index=0&id=41cc80fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cc80fe",
  null
  
)

export default component.exports